




















import Vue from 'vue'
import {
  Configuration,
  MeetingDetail,
  UploadedFile,
  ConferenceDoctorEntryMeetingRestControllerApi,
} from '@/types/api-docs'
import MeetingDetailForm from '@/components/MeetingDetailForm.vue'
import FileForm from '@/components/FileForm.vue'
import Utils from '@/utils/utils'

export interface DataType {
  pageName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breadcrumbs: Array<any>
  meeting?: MeetingDetail
  meetingsId: number
  uploadedFiles?: { [p: string]: UploadedFile }
  hasDisplayableUrl: boolean
  isFormValid: boolean
  eventType: string
}

const meetingApi = new ConferenceDoctorEntryMeetingRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export default Vue.extend({
  components: {
    FileForm,
    MeetingDetailForm,
  },
  data(): DataType {
    return {
      pageName: Utils.replaceOrganization(Utils.switchOrganization(this.$store.getters.organization, '学術集会', 'イベント'), this.$route.meta.title),
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: Utils.switchOrganization(this.$store.getters.organization, '学術集会', 'イベント') + '･セミナー一覧',
          href: '/member/meetings',
        },
        {
          text: Utils.replaceOrganization(Utils.switchOrganization(this.$store.getters.organization, '学術集会', 'イベント'), this.$route.meta.title),
          disabled: true,
        },
      ],
      meeting: undefined,
      meetingsId: Number(this.$route.params.id),
      uploadedFiles: undefined,
      hasDisplayableUrl: false,
      isFormValid: true,
      eventType: '',
    }
  },
  async mounted() {
    await this.fetchMeetingDetail()
    await this.fetchMeetingFiles()
    await this.countDisplayableUrl()
    this.eventType = Utils.switchOrganization(this.$store.getters.organization, '学術集会', 'イベント')
  },
  computed: {},
  methods: {
    async fetchMeetingDetail() {
      const { data } = await meetingApi.fetchMemberAttendMeetingDetail(this.meetingsId)
      this.meeting = data
    },
    async fetchMeetingFiles() {
      const { data } = await meetingApi.fetchMemberMeetingFiles(this.meetingsId)
      this.uploadedFiles = data
    },
    async countDisplayableUrl() {
      const { data } = await meetingApi.countMemberDisplayableSharedUrl(this.meetingsId)
      this.hasDisplayableUrl = data > 0
    },
    existFile() {
      if (!this.uploadedFiles) {
        return false
      }
      for (let key of Object.keys(this.uploadedFiles)) {
        if (this.uploadedFiles[key].url) {
          return true
        }
      }
      return false
    },
  },
})
